function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)
    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    const imageSwiperList = [
      ["https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro-1.jpg",
       "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro-2.jpg",
       "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro-3.jpg",
      "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro-4.jpg"
      ],
      ["https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro2-0.jpg",
       "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro2-1.jpg",
       "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro2-2.jpg",
      "https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20241127-pro2-3.jpg?v=1732688026"
      ]
    ]
    let prods = window.product
    console.log(prods)
    function getCur(){
      const val = $("#switch_list li.active").attr("data-val")
       let val2 = $('#sp-num li.active').attr('data-val')
      return prods.filter(item=> item.option1 == val && item.option2 === val2)[0]
    }
    function changePrice(){
      let num = $('#2').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)

      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-prices .sp-hots span").html(off_font);
    }

    $('.sp-buynow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    
    // 数量
    $('#2').change(function () {
      changePrice()
    })
    // 数字框初始化
    alignmentFns.initialize()
    new Swiper('#swiper2', {
      slidesPerView: 1.2,
      spaceBetween: 12,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.sp-part4-bg .swiper-button-next',
        prevEl: '.sp-part4-bg .swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper = new Swiper('#swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange(swiper_a){
          var sindex = swiper_a.activeIndex
          const list = document.querySelectorAll("#switch_list li")
          const imageIndex = $("#sp-num .active").index()
          $("#swiper .swiper-slide").eq(sindex).find("img").attr("src",imageSwiperList[imageIndex][sindex])
          
         for(let i=0;i<list.length;i++){
           if(i===sindex){
             list[i].classList.add("active")
           }else{
              list[i].classList.remove("active")
           }
         }
        },
      },
    })
    $('.sp-size-wraper li').click(function () {
      if($(this).parent(".sp-size-wraper").hasClass("sp-size-wraper-swiper")){
        var index = $(this).index()
        swiper.slideToLoop(index, 1000, false)
      }
       $(this).addClass('active').siblings().removeClass('active')
      changePrice()
             var sindex = swiper.activeIndex
          const list = document.querySelectorAll("#switch_list li")
          const imageIndex = $("#sp-num .active").index()
          $("#swiper .swiper-slide").eq(sindex).find("img").attr("src",imageSwiperList[imageIndex][sindex])
    })
    $('#addCart').click(function () {
        // do something here
        var data = {
          id: getCur().id,
          quantity: $('#2').val(),
        };
        
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $(".sp-buy-car span").html(result.item_count);
            });
          },
          dataType: "json",
        });
        
        var indexs = swiper.activeIndex
        console.log(indexs)
        let img = $('#swiper .swiper-slide-active img')
        if(indexs != 5){
          img = $('#swiper .swiper-slide-active img')
        }else{
          img = $('.sp-swiper-boxs img')
        }
        console.log('img', img[0].offsetTop, img.offset().left)
        var flyer = img.clone(true)
        flyer.addClass('clone')
        $('.sp-part5').append(flyer)
        $('.clone').css({
          width: 'auto',
          height: 'auto',
          position: 'fixed',
          top: 0,
          left: 70,
          'z-index': '99',
        })
        var offset = $('.sp-buy-car')[0].getBoundingClientRect()
        $('.sp-buy-car').addClass('shake')
        setTimeout(() => {
          $('.sp-buy-car').removeClass('shake')
        }, 1000)
        let finish = $('.sp-buy-car')
        $('.clone').animate(
          {
            top: 200,
            left: offset.left + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
  })

  var alignmentFns = {
  inputs: [],
  init: function (input, step, max, min, digit) {
    var width = 412
    var height = 121
    var _this = this
    width += 3

    input.attr('readonly', 'readonly')
    //设置不分样式
    input.css('border', 'none')
    input.css('width', width - height * 2 - 2)
    input.css('height', height)
    input.css('padding', '0px')
    input.css('margin', '0px')
    input.css('text-align', 'center')
    input.css('vertical-align', 'middle')
    input.css('line-height', height + 'px')
    input.css('background-color', 'transparent')

    //添加左右加减号
    input.wrap(
      "<div id = '" +
        input.attr('id') +
        "div' style = 'border-radius: 25px;overflow:hidden;display: flex;width:" +
        width +
        'px;height:' +
        height +
        "px;border: 1px solid #555555;'></div>"
    )
    input.before(
      "<div id = '" +
        input.attr('id') +
        "l'  onselectstart = 'return false;' style = 'font-size:56px;color:rgba(124, 124, 124, 1);-moz-user-select:none;cursor:pointer;text-align:center;width:" +
        height +
        'px;height:' +
        height +
        'px;line-height:' +
        height +
        "px;float:left;;color:#666666;'><img style='width:28px;height:11px' src='https://cdn.shopify.com/s/files/1/0706/5246/1375/files/9022a705161ff42b7879d88f1fd6d0e8.png?v=1718085653' alt=''></div>"
    )
    input.after(
      "<div id = '" +
        input.attr('id') +
        "r'  onselectstart = 'return false;' style = '-moz-user-select:none;cursor:pointer;text-align:center;font-size:56px;color:rgba(124, 124, 124, 1);width:" +
        height +
        'px;height:' +
        height +
        'px;line-height:' +
        height +
        "px;float:right;color:#666666;'><img style='width:32px;height:32px' src='https://cdn.shopify.com/s/files/1/0706/5246/1375/files/b230f59911b8d228791f36d23900d5ce.png?v=1718085653' alt=''></div>"
    )
    //左右调用执行
    $('#' + input.attr('id') + 'l').click(function () {
      _this.execute(input, step, max, min, digit, true)
    })
    $('#' + input.attr('id') + 'r').click(function () {
      _this.execute(input, step, max, min, digit, false)
    })
  },
  execute: function (input, step, max, min, digit, _do) {
    var val = parseFloat(this.format(input.val(), digit))
    var ori = val
    if (_do) val -= step
    if (!_do) val += step
    if (val < min) {
      val = min
    } else if (val > max) {
      val = max
    }
    input.val(this.format(val, digit)).change()
  },
  format: function (val, digit) {
    if (isNaN(val)) {
      val = 0
    }
    return parseFloat(val).toFixed(digit)
  },
  // 类型
  data: {
    default_data: {
      step: 0.1,
      min: 0,
      max: 99,
      digit: 1,
    },
  },
  // 初始化
  initialize: function () {
    //使用控件必须有以下属性或者引用alignment类
    var inputs = $(
      'input[user_data], input[data-digit], input[data-step], input[data-min], input[data-max], input.alignment'
    )

    inputs.each(function () {
      // 记录原始input代码
      alignmentFns.inputs.push(this.outerHTML)
      //预设值数据选择
      var data = alignmentFns.data

      var user_data = eval('data.' + $(this).attr('user_data'))
      if (user_data == null) {
        user_data = JSON.parse(JSON.stringify(data.default_data))
      }

      var digit = $(this).data('digit')
      if (digit != null && !isNaN(parseFloat(digit))) {
        digit = parseFloat(digit).toFixed(0)
        user_data.digit = parseFloat(digit)
      }

      var step = $(this).data('step')
      if (step != null && !isNaN(parseFloat(step))) {
        user_data.step = parseFloat(step)
      }
      var min = $(this).data('min')
      if (min != null && !isNaN(parseFloat(min))) {
        user_data.min = parseFloat(min)
      }

      var max = $(this).data('max')
      if (max != null && !isNaN(parseFloat(max))) {
        user_data.max = parseFloat(max)
      }
      //自动装载
      alignmentFns.init(
        $(this),
        user_data.step,
        user_data.max,
        user_data.min,
        user_data.digit
      )

      var data_edit = $(this).data('edit')
      if (data_edit) {
        $(this).attr('readonly', null)
      }
    })
  },
  destroy: function () {
    var inputs = this.inputs
    $.each(inputs, function (index, obj) {
      var input = $(obj)[0]
      var id = input.id
      $('#' + id + 'div').replaceWith(input)
    })
  },
  // 动态添加类型
  createType: function (types) {
    $.each(types, function (index, obj) {
      alignmentFns.data[obj.type] = obj.data
    })
  },
}

  
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        var targetElement = document.getElementById('shopping');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        } // 方式一
        // const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        // const offsetTop = targetElement.offsetTop
        // window.scroll({
        //   top: offsetTop * $('div#root').css('zoom'),
        //   behavior: 'smooth', // 使用 smooth 实现平滑滚动
        // }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
